import * as React from 'react';
import {
    Typography,
    Card,
    CardContent,
    Box,
    Button,
} from '@mui/material';
import CodeIcon from '@mui/icons-material/Code';
import { useNotify } from 'react-admin';
import { getConfig } from '../../framework/config/app.config';
import { useAppDataContext } from '../../framework/app/app.data.context';

export const EnvironmentApis = () => {
    const csApiUrl = getConfig('VITE_BASE_URL');
    const context = useAppDataContext();
    const notify = useNotify();

    const handleCopyToken = async () => {
        try {
            const token = await context?.appContext?.tokenProvider?.getIdToken();
            if (token) {
                await navigator.clipboard.writeText(token);
                notify('✅ Bearer token copied to clipboard! Paste it in the Swagger "Authorize" dialog.', { type: 'success' });
            } else {
                notify('❌ No auth token available', { type: 'error' });
            }
        } catch (error) {
            console.error('Failed to copy token:', error);
            notify('❌ Failed to copy token', { type: 'error' });
        }
    };

    return (
        <Card>
            <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Box>
                        <Typography variant="h6">
                            API Documentation Index
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                            Browse all available APIs organized by category. Click "Authorize" in Swagger and paste your bearer token.
                        </Typography>
                    </Box>
                    <Button
                        onClick={handleCopyToken}
                        startIcon={<CodeIcon />}
                        variant="contained"
                        color="success"
                        size="small"
                        sx={{ textTransform: 'none' }}
                    >
                        Copy Bearer Token
                    </Button>
                </Box>
                <iframe 
                    width="100%" 
                    height="850px" 
                    src={`${csApiUrl}/api/apps`} 
                    title="Commerce Services API Documentation"
                    style={{ border: '1px solid rgba(255, 255, 255, 0.1)', borderRadius: '4px' }}
                />
            </CardContent>
        </Card>
    );
};
